import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const createAction = action =>
  cloneElement(action, {
    className: 'cuiSiteAction',
  });

export const CuiSiteActions = ({ className, children, ...rest }) => {
  const actions = children.map(createAction);

  return (
    <div className={classNames('cuiSiteActions', className)} {...rest}>
      {actions}
    </div>
  );
};

CuiSiteActions.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
};

CuiSiteActions.defaultProps = {
  children: [],
  className: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/site/SiteActions.js